import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
    container: {
        width: '100%',
    },
}))

const CardList: React.FC = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.container}>{children}</div>
}

export { CardList }
